import { render, staticRenderFns } from "./InputVideo.vue?vue&type=template&id=3008cb2b&"
import script from "./InputVideo.vue?vue&type=script&lang=ts&"
export * from "./InputVideo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports